<router-outlet></router-outlet>

<div class="row tw-mt-4">
  <div class="col">
    <a bitButton bitIconButton="bwi-angle-left" routerLink="./" *ngIf="!homepage">
      {{ "backToReports" | i18n }}
    </a>
  </div>
</div>
